module.exports = "/_next/static/images/consultation-98953e6522ceb82c447cd9278d9fae16.png";